import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/app/core/http/api-endpoints';
import { map } from 'rxjs/operators';
import { MenuEntry } from '../models/menu-entry.model';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient, private julContextService: JulContextLibService) { }

  getMenu(): Observable<MenuEntry[]> {
    this.julContextService.setContextNational();
    if (localStorage.getItem('token'))
      return this.http.get(ApiEndpoints.core.menu.get()).pipe(
        map((response: any) => <MenuEntry[]>response.data)
      );
  }

    getMenuRegular(): Observable<any> {
      this.julContextService.setContextNational();
      if (localStorage.getItem('token'))
        return this.http.get(ApiEndpoints.core.menu.getRegular()).pipe(
            map((response: any) => response)
        );
    }

    getMenuAdmin(): Observable<any> {
      this.julContextService.setContextNational();
      if (localStorage.getItem('token'))
        return this.http.get(ApiEndpoints.core.menu.getAdmin()).pipe(
            map((response: any) => response)
        );
    }

    create(menu: any) {
      this.julContextService.setContextNational();
      return this.http.post(ApiEndpoints.core.menu.post(), menu);
    }

    update(menu: any) {
      this.julContextService.setContextNational();
      return this.http.put(ApiEndpoints.core.menu.put(), menu);
    }


    delete(id: string, version: string) {
      this.julContextService.setContextNational();
      return this.http.delete(ApiEndpoints.core.menu.delete(id, version));
    }

    saveMenuConfiguration(menu: any) {
      this.julContextService.setContextNational();
      return this.http.post(ApiEndpoints.core.menu.saveMenuConfiguration(), menu);

    }

    getMenuConfiguration(): Observable<any> {
      this.julContextService.setContextNational();
      return this.http.get<any>(ApiEndpoints.core.menu.getMenuConfiguration()).pipe(
          map((response: any) => <any>response.data)
      );
    }

}
